<script module lang="ts">
  const stepOrder = ["response", "confirm", "add_bank", "receive_pay"] as const;
  type StepKey = (typeof stepOrder)[number];
  type FlowStep = StepKey | "payment_sent";
  export type TaskStep = "waiting_for_updated_offer" | StepKey | "payment_sent";
</script>

<script lang="ts">
  import ListMagnifyingGlass from "~icons/ph/list-magnifying-glass";
  import ArrowsClockwise from "~icons/ph/arrows-clockwise";
  import CheckSquareOffset from "~icons/ph/check-square-offset";
  import Bank from "~icons/ph/bank";
  import HandCoins from "~icons/ph/hand-coins";
  import SettlementStatusUI from "../../../components/SettlementStatusUI.svelte";

  let {
    currentStep: taskCurrentStep,
    payoutAmount,
    objection = null,
    showButtonRow = false,
  }: {
    currentStep: TaskStep;
    payoutAmount: number;
    objection?: string | null;
    showButtonRow?: boolean;
  } = $props();

  let currentStep: FlowStep = $derived(taskCurrentStep === "waiting_for_updated_offer" ? "response" : taskCurrentStep);
  let steps = $derived([
    { name: "response", ...responseStepArgs(objection) },
    { name: "confirm", icon: CheckSquareOffset, label: "Confirm", subLabel: "Next", button: "Review offer" },
    { name: "add_bank", icon: Bank, label: "Bank", subLabel: "Next", button: "Add bank account" },
    { name: "receive_pay", ...receivePayStepArgs(currentStep) },
  ]);

  function responseStepArgs(objection: string | null) {
    if (objection == null) {
      return { icon: ListMagnifyingGlass, label: "Review", subLabel: "Next", button: "Review offer" };
    }

    switch (objection) {
      case "submitted":
        return {
          icon: ArrowsClockwise,
          label: "Counter",
          subLabel: "In progress",
          button: "View details",
          additionalText: "We’ll contact you once we hear from the finance company",
        };
      case "higher":
        return {
          icon: ListMagnifyingGlass,
          label: "Counter",
          subLabel: "Needs review",
          button: "Review offer",
          additionalText: "Counteroffer accepted: you got a higher offer!",
        };
      case "unchanged":
      default:
        return {
          icon: ListMagnifyingGlass,
          label: "Counter",
          subLabel: "Needs review",
          button: "Review offer",
          additionalText: "The finance company response is ready for review",
        };
    }
  }

  function receivePayStepArgs(currentStep: FlowStep) {
    return {
      icon: HandCoins,
      label: "Payment",
      subLabel: currentStep === "payment_sent" ? "Completed" : "In progress",
      button: "View details",
      additionalText: currentStep === "payment_sent" ? null : "We’ll notify you once payment is sent",
    };
  }
</script>
<SettlementStatusUI title="Your offer" amount={payoutAmount} {steps} current={currentStep} {showButtonRow} />
